<template>
    <div>
        <div class="form-group">
            <label for="descuento">Descuento en %</label>
            <ValidationProvider :name="'descuento_total' + index"  v-slot="{ errors }">
                <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" name="descuento" id="descuento_porcentaje" v-model="data.descuento_aplicado" @change="aplicadoDescuento('porcentaje')" :disabled="desactivar">
                    <option value="0">Sin descuento</option>
                    <template v-for="(descuento, index) in configuracion.descuento_aplicado">
                        <option :key="index" :value="descuento.valor">{{ descuento.label }}</option>
                    </template>
                </select>
            </ValidationProvider>
        </div>
        <div class="form-group" v-if="show_descuento">
            <label for="nombre">Descuento en €</label>
            <ValidationProvider :name="'descuento en €' + index"  v-slot="{ errors }">
                <input type="number" step="any" :max="importe" min="0" :disabled="desactivar" id="descuento_euros" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Descuento en €" v-model="data.descuento_integro" @input="aplicadoDescuento('integro')"/>
            </ValidationProvider>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data', 'index', 'desactivar', 'importe'],
        data() {
            return {
                show_descuento: true
            }
        },
        methods: {
            aplicadoDescuento(tipo) {
                switch (tipo) {
                    case 'porcentaje':
                        this.show_descuento = false;
                        this.data.descuento_integro = 0;
                        setTimeout(() => {
                            this.show_descuento = true;
                        }, 100)
                        break;
                    case 'integro':
                        this.data.descuento_aplicado = 0;
                        break;
                }
            }
        },
        mounted() {
            if (this.data.descuento_aplicado === undefined || this.data.descuento_aplicado === null) {
                this.$set(this.data, 'descuento_aplicado', 0);
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        }
    }
</script>